import React from "react";
import { useContent } from "../i18n/LanguageContext";
import { ChevronRight } from "lucide-react";

export default function Conditions({ onOpenAccount }) {
  const conditions = useContent().conditions;
  return (
    <section id="konditionen" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl reveal">
          <div className="gold-rule mb-6" />
          <h2 className="font-serif-lux text-4xl lg:text-5xl text-[#16233d] font-semibold">{conditions.title}</h2>
          <p className="mt-4 text-[#5c6577] text-lg">{conditions.text}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5 mt-12">
          {conditions.rows.map((r, i) => (
            <div
              key={r.term}
              className={`card-lift rounded-xl p-6 border ${
                i === conditions.rows.length - 1
                  ? "bg-[#16233d] border-[#16233d] text-white"
                  : "bg-white border-[#efe9dd]"
              }`}
            >
              <div className={`text-xs tracking-[0.15em] uppercase ${i === conditions.rows.length - 1 ? "text-white/60" : "text-[#8a8f9c]"}`}>
                {r.term}
              </div>
              <div className="mt-4 flex items-baseline gap-1">
                <span className={`font-serif-lux text-5xl ${i === conditions.rows.length - 1 ? "text-[#d3b077]" : "text-[#16233d]"}`}>
                  {r.rate.toFixed(2)}
                </span>
                <span className={`text-lg ${i === conditions.rows.length - 1 ? "text-[#d3b077]" : "text-[#b08d57]"}`}>%</span>
              </div>
              <div className={`text-xs mt-1 ${i === conditions.rows.length - 1 ? "text-white/50" : "text-[#8a8f9c]"}`}>
                {conditions.ratePa}
              </div>
              <button
                onClick={onOpenAccount}
                className={`mt-6 w-full rounded-md py-2.5 text-sm font-medium flex items-center justify-center gap-1.5 transition-all ${
                  i === conditions.rows.length - 1
                    ? "bg-[#b08d57] text-white hover:bg-[#c79f68]"
                    : "border border-[#d8d2c6] text-[#16233d] hover:border-[#b08d57] hover:text-[#8f6f3f]"
                }`}
              >
                {conditions.invest} <ChevronRight size={15} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
